var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddItinerary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.419,
    height: 14.153,
    viewBox: "0 0 17.419 14.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-folder-plus",
    "data-name": "Icon metro-folder-plus",
    d: "M12.369,7.961,10.192,5.784H2.571V19.937H19.99V7.961Zm2.177,7.621H12.369V17.76H10.192V15.582H8.014V13.4h2.177V11.228h2.177V13.4h2.177Z",
    transform: "translate(-2.571 -5.784)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItinerary);
export default __webpack_public_path__ + "static/media/add-itinerary.6ac8e94f6aab015b4d3472db3cca630d.svg";
export { ForwardRef as ReactComponent };